export const ENVIRONMENTS = {
  PROD: "prod",
  STAGING: "staging",
  DEV: "dev",
  LOCAL: "local",
} as const;

export const useEnvironment = () => {
  const environment = import.meta.env.FO_ENV;

  return {
    isProd: environment === ENVIRONMENTS.PROD,
    isStaging: environment === ENVIRONMENTS.STAGING,
    isDev: environment === ENVIRONMENTS.DEV,
    isLocal: environment === ENVIRONMENTS.LOCAL,
    environment,
  };
};
